import { Store } from 'redux';

import { selectRefreshToken } from '@bolteu/redux-session';
import { updateAccessTokenAsync } from '@bolteu/redux-session/build/src/actions';

import { ApiClient } from '../api';
import { GetAccessTokenResponse } from '../api/openapi_gen/deliveryProviderPortal/deliveryProviderAuthNoAuth/apis';

export class SessionService {
  constructor(private globalReduxStore: Store, private apiClient: ApiClient) {}

  public async updateAccessToken(
    updateAccessTokenPayload: boolean = true,
  ): Promise<GetAccessTokenResponse> {
    const reduxState = this.globalReduxStore.getState();
    const refreshToken = reduxState ? selectRefreshToken(reduxState) : null;

    const accessTokenResponse =
      await this.apiClient.deliveryProviderAuthNoAuth.publicGetAccessToken({
        refresh_token: refreshToken ?? '',
        update_access_token_payload: updateAccessTokenPayload,
      });

    this.globalReduxStore.dispatch(
      updateAccessTokenAsync.success({ accessToken: accessTokenResponse.access_token }),
    );
    return accessTokenResponse;
  }
}
